import AOS from 'aos'
import 'aos/dist/aos.css'

interface IObserverOptions {
  root: Element | Document | null
  rootMargin: string
  threshold: number | number[]
}

window.addEventListener('load', () => {
  setTimeout(() => {
    AOS.init({
      disable: 'mobile',
      once: true,
      easing: 'ease-out-quart',
    })
  }, 500)

  // Init intersection observer to handle init, if slider is in viewport
  if ('IntersectionObserver' in window) {
    // Create options for observer
    const observerOptions: IObserverOptions = {
      root: null,
      rootMargin: '-120px',
      threshold: 0,
    }

    const lazyObserver = new IntersectionObserver((entries) => {
      // Handle all entries (all images in this case)
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate')
        }
      })
    }, observerOptions)

    // Choose element to observe
    const elementToObserve = document.querySelectorAll('[data-aos-container]')

    if (elementToObserve.length) {
      elementToObserve.forEach((element) => {
        lazyObserver.observe(element)
      })
    }
  }
})
